import { APICurrentUser, PersonalSetting } from '@ardoq/api-types';
import { userOperations } from '@ardoq/core';
import {
  getDefaultLocale,
  getLocale,
  Locale,
  registerImplementation,
} from '@ardoq/locale';
import { logError } from '@ardoq/logging';

let currentLocale: Locale;

// --------------------------------------------------------------------------------------------------------------------
// Prefarebly this approach but since we don't use streams to provide this value (we use the get method),
// It will cause UX bug in ASSET_MANAGER.
//
// export const setLocaleFromUserSettings = (
//   currentUser: CurrentUserBackboneModel
// ) => {
//   const usersLocale = currentUser?.getPersonalSetting(PersonalSetting.LOCALE);
//   currentLocale = getLocaleCode(usersLocale) || getDefaultLocale();
// };
//
// export const initializeLocale = () =>
//   registerImplementation({
//     getCurrentLocale: () => {
//       if (currentLocale) return currentLocale;
//       currentLocale = getDefaultLocale();
//       return currentLocale;
//     },
//   });
// --------------------------------------------------------------------------------------------------------------------

export const setGlobalLocale = (locale: Locale) => {
  currentLocale = locale;
};

export const setLocaleFromUserSettings = (user: APICurrentUser) => {
  const usersLocale = userOperations.getPersonalSetting(
    user,
    PersonalSetting.LOCALE
  );

  setGlobalLocale(getLocale(usersLocale) ?? getDefaultLocale());
};
export const getCurrentLocale = () => {
  if (currentLocale) return currentLocale;

  // This error is not dangerous, however it is a red flag that we're reading
  // locale before it has been set.
  logError(
    new Error('Locale was read before initialization'),
    'Please update the code to receive the locale as a prop/param from locale$'
  );
  currentLocale = getDefaultLocale();
  return currentLocale;
};
export const initializeLocale = () =>
  registerImplementation({ getCurrentLocale });
